import ServiceCaller from '../libs/service-caller'

export class ControllerBase {
    ctx;

    constructor() {
        this.serviceCaller = new ServiceCaller("https://app.tokaly.com/TokalyServer/api/");
    }

    setCtx(ctx) {
        this.ctx = ctx;
    }
}